import { Group, Text } from "@mantine/core";

import classes from "./SessionsCalendar.module.css";

/**
 * The header cells of the grid, one per location. Rendered as a fragment so
 * each cell stays a direct child of the grid.
 */
export default function ColumnHeaders({ columns }) {
  return (
    <>
      {columns.map((column) => (
        <div key={column.key} className={classes.headerCell}>
          <Group gap={6} wrap="nowrap">
            <div
              className={classes.colorDot}
              style={{
                background: `var(--mantine-color-${column.color}-filled)`,
              }}
            />
            <Text size="sm" fw={600} truncate title={column.name}>
              {column.name}
            </Text>
            <Text size="xs" c="dimmed" style={{ flexShrink: 0 }}>
              {column.sessions.length}
            </Text>
          </Group>
        </div>
      ))}
    </>
  );
}
